<template>
  <BaseModal @close="$emit('close')">
    <template #toolbar>
      <div class="bg-white flex w-full rounded-md gap-x-3 -mb-3.5">
        <img
          src="../../../assets/images/instagram-image.png"
          alt=""
          class="w-11"
        >
        <!-- Right Side -->
        <div
          class="transform -translate-y-0.5"
        >
          <div class="text-lg font-semibold">
            Connect Instagram
          </div>
          <div
            class="text-sm text-gray-500"
          >
            Send ads to @foreplay_co using your account.
          </div>
        </div>
      </div>
    </template>
    <template #default>
      <div class="border-t border-border-normal">
        <!-- Step 1 -->
        <BaseInputV2
          v-if="step === 1"
          v-model="instagramHandle"
          v-validIGHandle
          :label="instagramLabel"
          placeholder="foreplay_co"
          class="my-5 mx-5"
          :errored="inputError"
          :error-message="'Please add an instagram handle'"
          @input="inputError = false"
        />
        <div
          v-if="step === 1"
          class="flex gap-x-1 ml-5 items-end"
        >
          <BaseText
            type="label"
            size="sm"
            class="text-text-muted"
          >
            Location
          </BaseText>
          <BaseText
            type="label"
            size="sm"
            class="text-text-subdued"
          >
            Where to save mobile ads
          </BaseText>
        </div>
        <BaseSingleSelect
          v-if="step === 1"
          class="mb-5 mt-1 mx-5"
          hover-color="transparent"
          no-search
          clear-dropdown
          multiple
          :max-items="4"
          :items="getBoards"
          :selected.sync="selectedBoards"
          item-value="name"
        >
          <template #item="{ item }">
            <div
              class="flex items-center justify-center w-full p-1.5 -my-1.5 rounded-md hover:bg-background-hover cursor-pointer transition-colors duration-70 ease-in "
              :class="selectedBoards.some(selectedBoard => item.id === selectedBoard.id) ? 'bg-background-normal' : ''"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                class="h-4 w-4 mr-1.5"
              >
                <path
                  d="M4.03502 16.6933L4.37551 16.0251H4.37551L4.03502 16.6933ZM3.30666 15.965L3.97491 15.6245H3.97491L3.30666 15.965ZM16.6933 15.965L16.0251 15.6245L16.0251 15.6245L16.6933 15.965ZM15.965 16.6933L15.6245 16.0251L15.6245 16.0251L15.965 16.6933ZM16.6933 4.03502L16.0251 4.37551L16.0251 4.37551L16.6933 4.03502ZM15.965 3.30666L15.6245 3.97491L15.6245 3.97491L15.965 3.30666ZM3.30666 4.03502L2.6384 3.69452L2.6384 3.69452L3.30666 4.03502ZM4.03502 3.30666L3.69452 2.6384L3.69452 2.6384L4.03502 3.30666ZM10.75 3.125V2.375H9.25V3.125H10.75ZM3.125 7.375H2.375V8.875H3.125V7.375ZM9.25 16.875V17.625H10.75V16.875H9.25ZM16.875 12.625H17.625V11.125H16.875V12.625ZM16.125 5.79167V14.2083H17.625V5.79167H16.125ZM14.2083 16.125H5.79167V17.625H14.2083V16.125ZM3.875 14.2083V5.79167H2.375V14.2083H3.875ZM5.79167 3.875H14.2083V2.375H5.79167V3.875ZM5.79167 16.125C5.31258 16.125 4.99837 16.1244 4.75808 16.1048C4.52654 16.0859 4.43042 16.0531 4.37551 16.0251L3.69452 17.3616C3.99613 17.5153 4.31163 17.5733 4.63593 17.5998C4.95147 17.6256 5.33733 17.625 5.79167 17.625V16.125ZM2.375 14.2083C2.375 14.6627 2.37442 15.0485 2.4002 15.3641C2.42669 15.6884 2.48472 16.0039 2.6384 16.3055L3.97491 15.6245C3.94693 15.5696 3.91413 15.4735 3.89522 15.2419C3.87558 15.0016 3.875 14.6874 3.875 14.2083H2.375ZM4.37551 16.0251C4.20303 15.9372 4.0628 15.797 3.97491 15.6245L2.6384 16.3055C2.87009 16.7602 3.2398 17.1299 3.69452 17.3616L4.37551 16.0251ZM16.125 14.2083C16.125 14.6874 16.1244 15.0016 16.1048 15.2419C16.0859 15.4735 16.0531 15.5696 16.0251 15.6245L17.3616 16.3055C17.5153 16.0039 17.5733 15.6884 17.5998 15.3641C17.6256 15.0485 17.625 14.6627 17.625 14.2083H16.125ZM14.2083 17.625C14.6627 17.625 15.0485 17.6256 15.3641 17.5998C15.6884 17.5733 16.0039 17.5153 16.3055 17.3616L15.6245 16.0251C15.5696 16.0531 15.4735 16.0859 15.2419 16.1048C15.0016 16.1244 14.6874 16.125 14.2083 16.125V17.625ZM16.0251 15.6245C15.9372 15.797 15.797 15.9372 15.6245 16.0251L16.3055 17.3616C16.7602 17.1299 17.1299 16.7602 17.3616 16.3055L16.0251 15.6245ZM17.625 5.79167C17.625 5.33733 17.6256 4.95147 17.5998 4.63593C17.5733 4.31163 17.5153 3.99613 17.3616 3.69452L16.0251 4.37551C16.0531 4.43042 16.0859 4.52654 16.1048 4.75808C16.1244 4.99837 16.125 5.31258 16.125 5.79167H17.625ZM14.2083 3.875C14.6874 3.875 15.0016 3.87558 15.2419 3.89522C15.4735 3.91413 15.5696 3.94693 15.6245 3.97491L16.3055 2.6384C16.0039 2.48472 15.6884 2.42669 15.3641 2.4002C15.0485 2.37442 14.6627 2.375 14.2083 2.375V3.875ZM17.3616 3.69452C17.1299 3.2398 16.7602 2.87009 16.3055 2.6384L15.6245 3.97491C15.797 4.0628 15.9372 4.20303 16.0251 4.37551L17.3616 3.69452ZM3.875 5.79167C3.875 5.31258 3.87558 4.99837 3.89522 4.75808C3.91413 4.52654 3.94693 4.43042 3.97491 4.37551L2.6384 3.69452C2.48472 3.99613 2.42669 4.31163 2.4002 4.63593C2.37442 4.95147 2.375 5.33733 2.375 5.79167H3.875ZM5.79167 2.375C5.33733 2.375 4.95147 2.37442 4.63593 2.4002C4.31163 2.42669 3.99613 2.48472 3.69452 2.6384L4.37551 3.97491C4.43042 3.94693 4.52654 3.91413 4.75808 3.89522C4.99837 3.87558 5.31258 3.875 5.79167 3.875V2.375ZM3.97491 4.37551C4.06279 4.20303 4.20303 4.06279 4.37551 3.97491L3.69452 2.6384C3.2398 2.87009 2.87009 3.2398 2.6384 3.69452L3.97491 4.37551ZM9.25 3.125V8.125H10.75V3.125H9.25ZM10 7.375H3.125V8.875H10V7.375ZM9.25 8.125V11.875H10.75V8.125H9.25ZM9.25 11.875V16.875H10.75V11.875H9.25ZM10 12.625H16.875V11.125H10V12.625Z"
                  fill="#5E6678"
                />
              </svg>
              <BaseText
                type="label"
                size="xs"
                class="w-max text-text-muted flex-1 whitespace-nowrap truncate select-none"
              >
                {{ item.name }}
              </BaseText>
              <svg
                v-if="
                  selectedBoards.some((selectedBoard) => {
                    return selectedBoard.id === item.id;
                  })
                "
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                class="w-4 h-4"
              >
                <path
                  d="M12.4998 7.9165L8.74984 12.4998L7.08317 10.8332M17.7082 9.99984C17.7082 14.257 14.257 17.7082 9.99984 17.7082C5.74264 17.7082 2.2915 14.257 2.2915 9.99984C2.2915 5.74264 5.74264 2.2915 9.99984 2.2915C14.257 2.2915 17.7082 5.74264 17.7082 9.99984Z"
                  stroke="#1F69FF"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </template>
          <template #selection="{ item }">
            <div class="flex items-center">
              <div class="flex items-center border border-border-hover rounded-md px-1.5 py-0.5 bg-background-normal gap-1.5 text-text-muted ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  class="h-4 w-4"
                >
                  <path
                    d="M4.03502 16.6933L4.37551 16.0251H4.37551L4.03502 16.6933ZM3.30666 15.965L3.97491 15.6245H3.97491L3.30666 15.965ZM16.6933 15.965L16.0251 15.6245L16.0251 15.6245L16.6933 15.965ZM15.965 16.6933L15.6245 16.0251L15.6245 16.0251L15.965 16.6933ZM16.6933 4.03502L16.0251 4.37551L16.0251 4.37551L16.6933 4.03502ZM15.965 3.30666L15.6245 3.97491L15.6245 3.97491L15.965 3.30666ZM3.30666 4.03502L2.6384 3.69452L2.6384 3.69452L3.30666 4.03502ZM4.03502 3.30666L3.69452 2.6384L3.69452 2.6384L4.03502 3.30666ZM10.75 3.125V2.375H9.25V3.125H10.75ZM3.125 7.375H2.375V8.875H3.125V7.375ZM9.25 16.875V17.625H10.75V16.875H9.25ZM16.875 12.625H17.625V11.125H16.875V12.625ZM16.125 5.79167V14.2083H17.625V5.79167H16.125ZM14.2083 16.125H5.79167V17.625H14.2083V16.125ZM3.875 14.2083V5.79167H2.375V14.2083H3.875ZM5.79167 3.875H14.2083V2.375H5.79167V3.875ZM5.79167 16.125C5.31258 16.125 4.99837 16.1244 4.75808 16.1048C4.52654 16.0859 4.43042 16.0531 4.37551 16.0251L3.69452 17.3616C3.99613 17.5153 4.31163 17.5733 4.63593 17.5998C4.95147 17.6256 5.33733 17.625 5.79167 17.625V16.125ZM2.375 14.2083C2.375 14.6627 2.37442 15.0485 2.4002 15.3641C2.42669 15.6884 2.48472 16.0039 2.6384 16.3055L3.97491 15.6245C3.94693 15.5696 3.91413 15.4735 3.89522 15.2419C3.87558 15.0016 3.875 14.6874 3.875 14.2083H2.375ZM4.37551 16.0251C4.20303 15.9372 4.0628 15.797 3.97491 15.6245L2.6384 16.3055C2.87009 16.7602 3.2398 17.1299 3.69452 17.3616L4.37551 16.0251ZM16.125 14.2083C16.125 14.6874 16.1244 15.0016 16.1048 15.2419C16.0859 15.4735 16.0531 15.5696 16.0251 15.6245L17.3616 16.3055C17.5153 16.0039 17.5733 15.6884 17.5998 15.3641C17.6256 15.0485 17.625 14.6627 17.625 14.2083H16.125ZM14.2083 17.625C14.6627 17.625 15.0485 17.6256 15.3641 17.5998C15.6884 17.5733 16.0039 17.5153 16.3055 17.3616L15.6245 16.0251C15.5696 16.0531 15.4735 16.0859 15.2419 16.1048C15.0016 16.1244 14.6874 16.125 14.2083 16.125V17.625ZM16.0251 15.6245C15.9372 15.797 15.797 15.9372 15.6245 16.0251L16.3055 17.3616C16.7602 17.1299 17.1299 16.7602 17.3616 16.3055L16.0251 15.6245ZM17.625 5.79167C17.625 5.33733 17.6256 4.95147 17.5998 4.63593C17.5733 4.31163 17.5153 3.99613 17.3616 3.69452L16.0251 4.37551C16.0531 4.43042 16.0859 4.52654 16.1048 4.75808C16.1244 4.99837 16.125 5.31258 16.125 5.79167H17.625ZM14.2083 3.875C14.6874 3.875 15.0016 3.87558 15.2419 3.89522C15.4735 3.91413 15.5696 3.94693 15.6245 3.97491L16.3055 2.6384C16.0039 2.48472 15.6884 2.42669 15.3641 2.4002C15.0485 2.37442 14.6627 2.375 14.2083 2.375V3.875ZM17.3616 3.69452C17.1299 3.2398 16.7602 2.87009 16.3055 2.6384L15.6245 3.97491C15.797 4.0628 15.9372 4.20303 16.0251 4.37551L17.3616 3.69452ZM3.875 5.79167C3.875 5.31258 3.87558 4.99837 3.89522 4.75808C3.91413 4.52654 3.94693 4.43042 3.97491 4.37551L2.6384 3.69452C2.48472 3.99613 2.42669 4.31163 2.4002 4.63593C2.37442 4.95147 2.375 5.33733 2.375 5.79167H3.875ZM5.79167 2.375C5.33733 2.375 4.95147 2.37442 4.63593 2.4002C4.31163 2.42669 3.99613 2.48472 3.69452 2.6384L4.37551 3.97491C4.43042 3.94693 4.52654 3.91413 4.75808 3.89522C4.99837 3.87558 5.31258 3.875 5.79167 3.875V2.375ZM3.97491 4.37551C4.06279 4.20303 4.20303 4.06279 4.37551 3.97491L3.69452 2.6384C3.2398 2.87009 2.87009 3.2398 2.6384 3.69452L3.97491 4.37551ZM9.25 3.125V8.125H10.75V3.125H9.25ZM10 7.375H3.125V8.875H10V7.375ZM9.25 8.125V11.875H10.75V8.125H9.25ZM9.25 11.875V16.875H10.75V11.875H9.25ZM10 12.625H16.875V11.125H10V12.625Z"
                    fill="#5E6678"
                  />
                </svg>
                <BaseText
                  type="label"
                  size="xs"
                  class="w-max text-text-muted flex-1 whitespace-nowrap truncate select-none"
                >
                  {{ item.name }}
                </BaseText>
              </div>
            </div>
          </template>

          <template #icon>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="-mx-2 text-text-muted"
            >
              <path
                d="M4.03502 16.6933L4.37551 16.0251H4.37551L4.03502 16.6933ZM3.30666 15.965L3.97491 15.6245H3.97491L3.30666 15.965ZM16.6933 15.965L16.0251 15.6245L16.0251 15.6245L16.6933 15.965ZM15.965 16.6933L15.6245 16.0251L15.6245 16.0251L15.965 16.6933ZM16.6933 4.03502L16.0251 4.37551L16.0251 4.37551L16.6933 4.03502ZM15.965 3.30666L15.6245 3.97491L15.6245 3.97491L15.965 3.30666ZM3.30666 4.03502L2.6384 3.69452L2.6384 3.69452L3.30666 4.03502ZM4.03502 3.30666L3.69452 2.6384L3.69452 2.6384L4.03502 3.30666ZM10.75 3.125V2.375H9.25V3.125H10.75ZM3.125 7.375H2.375V8.875H3.125V7.375ZM9.25 16.875V17.625H10.75V16.875H9.25ZM16.875 12.625H17.625V11.125H16.875V12.625ZM16.125 5.79167V14.2083H17.625V5.79167H16.125ZM14.2083 16.125H5.79167V17.625H14.2083V16.125ZM3.875 14.2083V5.79167H2.375V14.2083H3.875ZM5.79167 3.875H14.2083V2.375H5.79167V3.875ZM5.79167 16.125C5.31258 16.125 4.99837 16.1244 4.75808 16.1048C4.52654 16.0859 4.43042 16.0531 4.37551 16.0251L3.69452 17.3616C3.99613 17.5153 4.31163 17.5733 4.63593 17.5998C4.95147 17.6256 5.33733 17.625 5.79167 17.625V16.125ZM2.375 14.2083C2.375 14.6627 2.37442 15.0485 2.4002 15.3641C2.42669 15.6884 2.48472 16.0039 2.6384 16.3055L3.97491 15.6245C3.94693 15.5696 3.91413 15.4735 3.89522 15.2419C3.87558 15.0016 3.875 14.6874 3.875 14.2083H2.375ZM4.37551 16.0251C4.20303 15.9372 4.0628 15.797 3.97491 15.6245L2.6384 16.3055C2.87009 16.7602 3.2398 17.1299 3.69452 17.3616L4.37551 16.0251ZM16.125 14.2083C16.125 14.6874 16.1244 15.0016 16.1048 15.2419C16.0859 15.4735 16.0531 15.5696 16.0251 15.6245L17.3616 16.3055C17.5153 16.0039 17.5733 15.6884 17.5998 15.3641C17.6256 15.0485 17.625 14.6627 17.625 14.2083H16.125ZM14.2083 17.625C14.6627 17.625 15.0485 17.6256 15.3641 17.5998C15.6884 17.5733 16.0039 17.5153 16.3055 17.3616L15.6245 16.0251C15.5696 16.0531 15.4735 16.0859 15.2419 16.1048C15.0016 16.1244 14.6874 16.125 14.2083 16.125V17.625ZM16.0251 15.6245C15.9372 15.797 15.797 15.9372 15.6245 16.0251L16.3055 17.3616C16.7602 17.1299 17.1299 16.7602 17.3616 16.3055L16.0251 15.6245ZM17.625 5.79167C17.625 5.33733 17.6256 4.95147 17.5998 4.63593C17.5733 4.31163 17.5153 3.99613 17.3616 3.69452L16.0251 4.37551C16.0531 4.43042 16.0859 4.52654 16.1048 4.75808C16.1244 4.99837 16.125 5.31258 16.125 5.79167H17.625ZM14.2083 3.875C14.6874 3.875 15.0016 3.87558 15.2419 3.89522C15.4735 3.91413 15.5696 3.94693 15.6245 3.97491L16.3055 2.6384C16.0039 2.48472 15.6884 2.42669 15.3641 2.4002C15.0485 2.37442 14.6627 2.375 14.2083 2.375V3.875ZM17.3616 3.69452C17.1299 3.2398 16.7602 2.87009 16.3055 2.6384L15.6245 3.97491C15.797 4.0628 15.9372 4.20303 16.0251 4.37551L17.3616 3.69452ZM3.875 5.79167C3.875 5.31258 3.87558 4.99837 3.89522 4.75808C3.91413 4.52654 3.94693 4.43042 3.97491 4.37551L2.6384 3.69452C2.48472 3.99613 2.42669 4.31163 2.4002 4.63593C2.37442 4.95147 2.375 5.33733 2.375 5.79167H3.875ZM5.79167 2.375C5.33733 2.375 4.95147 2.37442 4.63593 2.4002C4.31163 2.42669 3.99613 2.48472 3.69452 2.6384L4.37551 3.97491C4.43042 3.94693 4.52654 3.91413 4.75808 3.89522C4.99837 3.87558 5.31258 3.875 5.79167 3.875V2.375ZM3.97491 4.37551C4.06279 4.20303 4.20303 4.06279 4.37551 3.97491L3.69452 2.6384C3.2398 2.87009 2.87009 3.2398 2.6384 3.69452L3.97491 4.37551ZM9.25 3.125V8.125H10.75V3.125H9.25ZM10 7.375H3.125V8.875H10V7.375ZM9.25 8.125V11.875H10.75V8.125H9.25ZM9.25 11.875V16.875H10.75V11.875H9.25ZM10 12.625H16.875V11.125H10V12.625Z"
                fill="currentColor"
                fill-opacity="0.5"
              />
            </svg>
          </template>
        </BaseSingleSelect>
        <!-- Step 2 -->
        <div
          v-if="step === 2"
          class="flex flex-col gap-y-3.5 mx-5 my-5"
        >
          <BaseText
            type="label"
            size="lg"
            class="text-text-loud w-full"
          >
            Verify your account:
          </BaseText>
          <BaseText
            type="body"
            size="sm"
            class="text-text-muted"
          >
            Message the code <span class="text-primary-blue-100"> {{ verificationCode }} </span> to @foreplay_co on Instagram, to finish linking your Instagram account with Foreplay.
          </BaseText>
        </div>
        <div
          class="pt-5 border-t border-border-normal mt-5"
        >
          <div class="flex">
            <BaseButton
              v-if="step === 1"
              primary
              :destroy="getUser.igUsername?.length && !instagramHandle"
              :disabled="isButtonDisabled"
              :loading="loading"
              class="ml-auto mr-5"
              @click="connectInstagram"
            >
              <div
                class="flex gap-x-1.5"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                >
                  <path
                    d="M14.557 16.7746C13.3786 17.5055 11.9886 17.9274 10.5 17.9274C6.2428 17.9274 2.79166 14.4763 2.79166 10.2191C2.79166 5.96188 6.2428 2.51074 10.5 2.51074C14.7572 2.51074 18.2083 5.96188 18.2083 10.2191C18.2083 11.8688 17.3885 13.5726 15.4762 13.3987C13.9031 13.2557 12.7707 11.8239 12.9941 10.2601L13.4355 7.22139M12.9479 10.6195C12.6917 12.4425 11.1909 13.7386 9.59572 13.5144C8.00057 13.2903 6.91514 11.6307 7.17135 9.80762C7.42756 7.98459 8.92839 6.68847 10.5235 6.91265C12.1187 7.13683 13.2041 8.79643 12.9479 10.6195Z"
                    stroke="white"
                    stroke-width="1.25"
                    stroke-linecap="round"
                  />
                </svg>
                {{ getButtonText }}
              </div>
            </BaseButton>
            <BaseButton
              v-if="step === 2"
              primary
              class="ml-auto mr-5"
              @click="copyAndRedirect"
            >
              <div
                class="flex gap-x-1.5"
              >
                Copy code and open in Instagram
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class
                >
                  <path
                    d="M15.2083 11.6667V14.2083C15.2083 15.1418 15.2083 15.6085 15.0267 15.965C14.8669 16.2786 14.6119 16.5336 14.2983 16.6933C13.9418 16.875 13.4751 16.875 12.5417 16.875H5.79167C4.85825 16.875 4.39154 16.875 4.03502 16.6933C3.72141 16.5336 3.46644 16.2786 3.30666 15.965C3.125 15.6085 3.125 15.1418 3.125 14.2083V7.39583C3.125 6.52132 3.125 6.08407 3.28502 5.74574C3.44988 5.39717 3.7305 5.11655 4.07907 4.95168C4.4174 4.79167 4.85466 4.79167 5.72917 4.79167H7.70833M11.4583 3.125H16.875M16.875 3.125V8.54167M16.875 3.125L9.16667 10.8333"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </BaseButton>
          </div>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import FirebaseAPI from '@/api/firebase'
import firebase from '../../../api/config/FirebaseConfig'
export default {
  name: 'InstagramModal',
  directives: {
    validIGHandle: {
      inserted: function (el, binding, vnode) {
        el.addEventListener('keypress', function (e) {
          const key = String.fromCharCode(e.keyCode)
          if (!/[a-zA-Z0-9_.]/.test(key)) {
            e.preventDefault()
            vnode.context.setDisallowedKeyFlag(true)
          }
        })
      }
    }
  },
  data () {
    return {
      instagramHandle: '',
      selectedBoards: [],
      inputError: false,
      dropdownError: false,
      loading: false,
      verificationCode: null,
      step: 1,
      disabled: false,
      disallowedKeyUsed: false
    }
  },
  computed: {
    instagramLabel () {
      if (this.disallowedKeyUsed) {
        return 'Your IG Handle - no link or @ needed'
      }
      return 'Your IG Handle'
    },
    ...mapGetters('BoardsModule', ['getBoards']),
    ...mapGetters('AuthModule', ['getUser']),
    isButtonDisabled () {
      const selectedBoardIds = this.selectedBoards.map(board => board.id)
      const haveSameElements = this.getUser.igBoardIds && (selectedBoardIds.every(id => this.getUser.igBoardIds.includes(id)) && this.getUser.igBoardIds.every(id => selectedBoardIds.includes(id)))
      return (!this.getUser.igUsername?.length && !this.instagramHandle) || (this.instagramHandle === this.getUser.igUsername && haveSameElements)
    },
    getButtonText () {
      let buttonText = 'Requires Username'
      if (this.getUser.igUsername) {
        // default for if the user already has an account connected
        buttonText = 'Change IG'
      } else {
        // default for if the user doesn't have an account connected
        buttonText = 'Connect IG'
      }
      // if the user has a current ig and hasnt changed theirs. handle and has changed their boards
      const selectedBoardIds = this.selectedBoards.map(board => board.id)
      const haveSameElements = this.getUser.igBoardIds && (selectedBoardIds.every(id => this.getUser.igBoardIds.includes(id)) && this.getUser.igBoardIds.every(id => selectedBoardIds.includes(id)))
      if (!haveSameElements && this.instagramHandle === this.getUser.igUsername) {
        buttonText = 'Change Boards'
      }
      if (this.getUser.igUsername && !this.instagramHandle) {
        // if the user has a current ig handle but wants to remove their handle
        buttonText = 'Remove IG'
      }

      return buttonText
    }
  },
  async mounted () {
    // fetching user from database inorder to get igUsername and igBoardIds (used on initial load)
    const db = firebase.firestore()
    const user = firebase.auth().currentUser
    const userData = await db.collection('auth-users').doc(user.uid).get()
    this.SET_USER({ ...this.getUser, ...userData.data() })

    // setting initial values
    this.verificationCode = (Math.floor(100000 + Math.random() * 900000)).toString()
    if (this.getUser.igUsername) {
      this.instagramHandle = this.getUser.igUsername
    }
    if (this.getUser.igBoardIds && this.getUser.igBoardIds.length) {
      this.selectedBoards = this.getBoards.filter(board => {
        return this.getUser.igBoardIds.includes(board.id)
      })
    }
  },
  methods: {
    setDisallowedKeyFlag (value) {
      this.disallowedKeyUsed = value
    },
    ...mapMutations('AuthModule', ['SET_USER_IG_BOARD_IDS', 'SET_USER_IG_USERNAME', 'SET_USER']),
    async copyAndRedirect () {
      await this.$copyText(this.verificationCode)
      window.open('https://www.instagram.com/foreplay_co/', '_blank')
    },
    async connectInstagram () {
      this.loading = true

      // handle remove current igUsername
      if (this.getUser.igUsername && !this.instagramHandle) {
        await this.disconnectInstagram()
        this.loading = false
        this.$emit('close')
        return
      }

      // get user
      const user = firebase.auth().currentUser

      // handle change igBoardIds
      const boardIds = this.selectedBoards.map(board => board.id)
      await FirebaseAPI.Users.update(user.uid, { igBoardIds: boardIds })
      this.SET_USER_IG_BOARD_IDS(boardIds)
      const selectedBoardIds = this.selectedBoards.map(board => board.id)
      const haveSameElements = this.getUser.igBoardIds && (selectedBoardIds.every(id => this.getUser.igBoardIds.includes(id)) && this.getUser.igBoardIds.every(id => selectedBoardIds.includes(id)))
      this.$emit('refresh')
      if (haveSameElements && this.instagramHandle === this.getUser.igUsername) {
        this.loading = false
        this.$showAlert({
          message: 'Instagram boards updated',
          type: 'success'
        })
        this.$emit('close')
        return
      }
      if (this.instagramHandle) {
        // the case where the user wants to add a handle or change their handle
        const username = this.instagramHandle.startsWith('@') ? this.instagramHandle.substring(1) : this.instagramHandle
        await FirebaseAPI.Users.update(user.uid, { igUsername: username, igVerificationCode: `${this.verificationCode}`, igWaitingVerification: true })
        this.SET_USER_IG_USERNAME(username)
        this.loading = false
        this.step = 2
        this.$emit('refresh')
      } else {
        this.$emit('close')
        this.$emit('refresh')
      }
    },
    async disconnectInstagram () {
      const user = firebase.auth().currentUser
      await FirebaseAPI.Users.update(user.uid, { igUsername: firebase.firestore.FieldValue.delete(), igVerificationCode: firebase.firestore.FieldValue.delete(), igWaitingVerification: firebase.firestore.FieldValue.delete(), igBoardIds: firebase.firestore.FieldValue.delete(), igConversationId: firebase.firestore.FieldValue.delete() })
      this.SET_USER_IG_BOARD_IDS([])
      this.SET_USER_IG_USERNAME(null)
      this.$emit('refresh')
    }
  }
}
</script>

<style scoped></style>
